import React from 'react';
import { js_utils } from '../utils/frfr-js-utils';
import { is_virtel_object } from '../utils/frfr-virtel-utils';
import JSDisplayArray from './JSDisplayArray';
import JSDisplayObject from './JSDisplayObject';
import JSDisplayObjectVirtel from './JSDisplayObjectVirtel';

/*
Optimal order for else if else...:

string
boolean
null
undefined
number
array
object
symbol
bigint
function
*/

//
const JSDisplayValue = (props) => {
  // let val = props.val;
  // let val;
  const val = props.val;
  const key = props.key_name; // only for primitive_validator
  let jsx = null;
  //
  let primitive_validator;
  if (typeof props.primitive_validator === 'function') {
    primitive_validator = props.primitive_validator;
  } else {
    primitive_validator = () => { return true };
  }
  const _cl_primitive_valid_make = (val) => {
    let cl_primitive_valid = "";
    if (primitive_validator(key, val) === false) {
      cl_primitive_valid = " primitive-value--is-invalid";
    }
    return cl_primitive_valid;
  };
  //
  let _cb_res;
  if (typeof props.cb === 'function') {
    _cb_res = props.cb(val);
  }
  //
  if (_cb_res && _cb_res[0] === true) {
    jsx = _cb_res[1]; // CUSTOM JSX
  } else {
    //
    if (typeof val === 'undefined') { // PRIMITIVE
      jsx = (
        <div className={"frfr-js-display-primitive-value frfr-js-display-primitive-value--undefined frfr-js-display-simple-value--sticky " + _cl_primitive_valid_make(val)}><span>undefined</span></div>
      );
      // } else if (js_utils.is_null(val)) {
    } else if (val === null) { // PRIMITIVE
      jsx = (
        <div className={"frfr-js-display-primitive-value frfr-js-display-primitive-value--null frfr-js-display-simple-value--sticky " + _cl_primitive_valid_make(val)}><span>null</span></div>
      );
    } else if (typeof val === 'string') { // PRIMITIVE
      if (val === '') {
        /*
        jsx = (
          <div className={"frfr-js-display-primitive-value frfr-js-display-primitive-value--string-empty" + _cl_primitive_valid_make(val)}><span></span></div>
        );
        */
        jsx = (
          <div className={"frfr-js-display-primitive-value frfr-js-display-primitive-value--string-empty frfr-js-display-primitive-value--string-empty--with-icons frfr-js-display-simple-value--sticky " + _cl_primitive_valid_make(val)}><span className="frfr-js-display-primitive-value--string-empty__icons"><abbr title="empty string"><i className="fa fa-quote-left" aria-hidden="true"></i><i className="fa fa-quote-right" aria-hidden="true"></i></abbr></span></div>
        );
      } else {
        jsx = (
          <div className={"frfr-js-display-primitive-value frfr-js-display-primitive-value--string" + _cl_primitive_valid_make(val)}><span>{val}</span></div>
        );
      }
    } else if (typeof val === 'boolean') { // PRIMITIVE
      let display_bool = 'false';
      if (val === true) {
        display_bool = 'true';
      }
      jsx = (
        <div className={"frfr-js-display-primitive-value frfr-js-display-primitive-value--bool  frfr-js-display-simple-value--sticky frfr-js-display-primitive-value--bool--" + display_bool + ' ' + _cl_primitive_valid_make(val)}>
          <span>{display_bool}</span>
        </div>
      );
    } else if (typeof val === 'number' && isNaN(val)) { // PRIMITIVE
      // <div className="uu-anytable__cell__inner uu-anytable__cell__inner--fill-absolute uu-text-right">
      jsx = (
        <div className="uu-text-right">
          <div className={"frfr-js-display-primitive-value frfr-js-display-primitive-value--nan frfr-js-display-simple-value--sticky " + _cl_primitive_valid_make(val)}><span>{'NaN'}</span></div>
        </div>
      );
    } else if (typeof val === 'number') { // PRIMITIVE
      jsx = (
        <div className={"frfr-js-display-primitive-value frfr-js-display-primitive-value--number " + _cl_primitive_valid_make(val)}><span>{val}</span></div>
      );
    } else if (Array.isArray(val)) {
      jsx = (
        <JSDisplayArray val={val} initialCollapsed={props.initialCollapsed} cb={props.cb} primitive_validator={primitive_validator} sharedProps={props.sharedProps} />
      );
    } else if (js_utils.is_object(val)) {
      // console.log('%c *********************************', 'background: #222; color: #bada55');
      // console.log(val);
      if (is_virtel_object(val)) {
        // console.log(true)
        // let sound = n
        // new Audio("/static/audio/beep-06.mp3"); // buffers automatically when created
        // sound.play();
        jsx = (
          <JSDisplayObjectVirtel val={val} initialCollapsed={props.initialCollapsed} primitive_validator={primitive_validator} sharedProps={props.sharedProps} />
        );
      } else {
        // console.log(false)
        jsx = (
          <JSDisplayObject val={val} initialCollapsed={props.initialCollapsed} cb={props.cb} primitive_validator={primitive_validator} sharedProps={props.sharedProps} />
        );
      }
    } else if (typeof val === 'symbol') { // PRIMITIVE symbol
      // TODO
      jsx = (
        <div className={"frfr-js-display-primitive-value frfr-js-display-primitive-value--symbol  frfr-js-display-simple-value--sticky " + _cl_primitive_valid_make(val)}>
          <span>symbol</span>
        </div>
      );
    } else if (typeof val === 'bigint') { // TYPE bigint
      // TODO
      //         <div className="uu-anytable__cell__inner uu-anytable__cell__inner--fill-absolute uu-text-right">
      jsx = (
        <div className="uu-text-right">
          <div className={"frfr-js-display-primitive-value frfr-js-display-primitive-value--bigint frfr-js-display-simple-value--sticky " + _cl_primitive_valid_make(val)}><span>bigint</span></div>
        </div>
      );
    } else if (typeof val === 'function') { // TYPE FUNCTION
      jsx = (
        <div className={"frfr-js-display-primitive-value frfr-js-display-primitive-value--function  frfr-js-display-simple-value--sticky "}>
          <span>function</span>
        </div>
      );
    } else {
      console.log('OTHER typeof VALUE: ', val);
      jsx = (
        <div className={"frfr-js-display-primitive-value frfr-js-display-primitive-value--undefined  frfr-js-display-simple-value--sticky" + _cl_primitive_valid_make(val)}><span>type: {(typeof val)}</span></div>
      );
    }
    //
  }
  //
  return (
    <>
      {jsx}
    </>
  );
};

export default JSDisplayValue;